import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "identifierSelect", "input"];

  change(event) {
    const placeholders = {
      "serial": "4AC7899F1",
      "subject_key_id": "37638729f9c601971baeceacf30245c43381c7f0",
      "issuer_name": "%Apple%",
      "homebrew_package": "sqlite",
      "common_name": "www.apple.com",
      "expiry_threshold": 30,
      "extension_name": "1Password",
      "extension_id": "fhhbdiojplfjncoa",
      "process_name": "1Password",
      "process_path": "Applications/1Password.app/1Password"
    };

    let identifier = event.target.value
    let label =  placeholders[identifier];

    this.inputTarget.placeholder = label
  }
}
